define('ordersDetailMailsView',[
    'module',
    'backbone',
    'underscore',
    'app',
    'tableView',
    'tableDatetimeFieldView',
    'mailsMailView'
], function (
    Module,
    Backbone,
    _,
    App,
    TableView,
    DatetimeFieldView,
    MailView
) {
    'use strict';

    Module.exports = TableView.extend({
        className: 'orders-detail-mails-view ' + TableView.prototype.className,
        pageSize: 50,
        pageMode: 'pagination',

        setFields: function() {
            var fields = [];

            fields.push({
                name: 'Date',
                label: _.i18n('common.date'),
                bind: 'sentDate',
                className: 'sentDate',
                view: DatetimeFieldView
            });

            fields.push({
                name: 'subject',
                label: _.i18n('common.subject'),
                bind: 'subject',
                className: 'subject'
            });

            fields.push({
                name: 'labels',
                label: _.i18n('common.label'),
                bind: 'labels',
                className: 'labels',
                formatter: function(value) {
                    if (!value || !value.length) return '';
                    // Map the array of label objects to their names and join with commas
                    return _.map(value, function(label) {
                        var col = label.textColor?label.textColor:'';
                        var bgCol = label.backgroundColor?label.backgroundColor:'';
                        return '<div class="label-view" style="background-color: '+bgCol+'; color: '+col+'">' + label.name + '</div>';
                    }).join('');
                }
            });


            return fields;
        },

        fetch: function(first, pageSize) {
            var defer = $.Deferred();

            if(!first) first = 0;
            if(pageSize) this.pageSize = pageSize;

            var params = {};
            params.page = Math.ceil(first/this.pageSize);
            params.size = this.pageSize;

            if(this.fetchRequest)
                this.fetchRequest.abort();

            this.fetchRequest = $.ajax({
                type: 'GET',
                url: this.model.get('order').getMailsUrl(params),
                success: _.bind(function (items) {
                    var models = [];
                    _.each(items.content, _.bind(function(item) {
                        var model = App.request('mails:model', item);
                        models.push(model);
                    }, this));
                    defer.resolve(models, items.totalElements);
                }, this)
            });

            return defer.promise();
        },

        onRowDoubleClick: function (view) {
            MailView.prototype.open(view.model, view.model.get('emailAddress').secId);
        }

    });
});
